module.exports = __webpack_public_path__ + "static/media/platinum-1.2e53ef85.webp";